/**
 * Array of CSS selectors to follow & preload (see below)
 * @type {string[]}
 */
const yesSelectors = ['a[href]'];

/**
 * Array of CSS selectors to NOT follow & preload (see below)
 * @type {string[]}
 */
const noSelectors = [
  'a[href*=actions]',
  'a[href*=one]',
  'a[href^="#"]',
];

/**
 * Tweak default navigation behavior
 * https://unpoly.com/navigation
 * @type {boolean}
 */
up.fragment.config.navigateOptions.focus = false;

/**
 * Automatically follow (most) internal links
 * https://unpoly.com/up.link.config#config.followSelectors
 * https://unpoly.com/up.link.config#config.noFollowSelectors
 */
up.link.config.followSelectors.push(...yesSelectors);
up.link.config.noFollowSelectors.push(...noSelectors);

/**
 * Automatically preload (most) internal links
 * https://unpoly.com/up.link.config#config.preloadSelectors
 * https://unpoly.com/up.link.config#config.noPreloadSelectors
 */
up.link.config.preloadSelectors.push(...yesSelectors);
up.link.config.noPreloadSelectors.push(...noSelectors);

/**
 * Allow running scripts in fragments
 * https://unpoly.com/up.fragment.config#config.runScripts
 * @type {boolean}
 */
up.fragment.config.runScripts = true;

/**
 * Prevent Unpoly from caching requests to URLs starting with "/shop" or "/zh/shop"
 * https://unpoly.com/up.network.config#config.autoCache
 */
let defaultAutoCache = up.network.config.autoCache;
up.network.config.autoCache = function(request) {
  const url = request.url;
  if (url.startsWith('/shop') || url.startsWith('/zh/shop')) {
    return false;
  }
  return defaultAutoCache(request);
};
